var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"by"},[_c('p',[_vm._v("Created by "),_c('a',{attrs:{"href":"https://github.com/BetaHuhn"}},[_vm._v("BetaHuhn")])])])}]

export { render, staticRenderFns }